<template>
    <div ref="gruppeCard" class="card">
        <div :id="$id('gruppe-gesamt')" :class="borderColor" style="padding-bottom: 0px;">
            <Header ref="header" :data-id="$id('header')"
                    :name="gruppe.i18NName" :visible="isSomeSelected"
                    :i18NPictureId="gruppe.i18NPictureId"
                    :i18NDescription="gruppe.i18NDescription"
                    v-on:reset-elements="resetAttributs"/>
            <Attribut ref="attributs" class="border-top padding-top"
                      v-for="(attribut) in gruppe.attribute" v-bind:key="attribut.name"
                      :attribut="attribut" :gruppenName="gruppe.i18NName"/>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/config-page/utils/Header";
    import Attribut from "@/components/config-page/produktmerkmale/Attribut";
    import isEmpty from "@/mixins/isempty";

    export default {
        name: 'Gruppe',
        mixins: [isEmpty],
        components: {Header, Attribut},
        props: ['gruppe'],
        computed: {
            isSelected: function () {
                return this.$props.gruppe.attribute.every(attribut => (!this.isEmpty(attribut.selectedEingabeWert) || !this.isEmpty(attribut.selectedAuswahlWert)));
            },
            isSomeSelected: function () {
                return this.$props.gruppe.attribute.some(attribut => (!this.isEmpty(attribut.selectedEingabeWert) || !this.isEmpty(attribut.selectedAuswahlWert)));
            },
            borderColor: function () {
                if (this.isSelected) {
                    return "card-body green-left-border";
                }
                return "card-body orange-left-border";
            }
        },
        methods: {
            resetAttributs() {
                let gruppe = this.gruppe;
                this.$store.commit('resetGruppe', {gruppe: gruppe});
            }
        }
    }
</script>

<style scoped>

    .border-top {
        border-top: gray solid;
    }


    .padding-top {
        padding-top: 5px;
    }
</style>